import { render } from "./MsDatePicker.vue?vue&type=template&id=45bfa262&scoped=true"
import script from "./MsDatePicker.vue?vue&type=script&lang=js"
export * from "./MsDatePicker.vue?vue&type=script&lang=js"

import "./MsDatePicker.vue?vue&type=style&index=0&id=45bfa262&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bfa262"]])

export default __exports__